/** Branded messages for the `locale-suggestion.json` namespace. */
import type { PublicLocale } from '@/lib/locale-prefix'
import { brandMessages } from '@/lib/brands/messages'

import localeSuggestionEs from '@/locales/es/locale-suggestion.json'
import localeSuggestionEn from '@/locales/en/locale-suggestion.json'
import localeSuggestionPt from '@/locales/pt/locale-suggestion.json'
import localeSuggestionIt from '@/locales/it/locale-suggestion.json'
import localeSuggestionFr from '@/locales/fr/locale-suggestion.json'
import localeSuggestionJa from '@/locales/ja/locale-suggestion.json'
import localeSuggestionDe from '@/locales/de/locale-suggestion.json'

export type LocaleSuggestionMessages = typeof localeSuggestionEs

export const LOCALE_SUGGESTION_BY_LOCALE: Record<PublicLocale, LocaleSuggestionMessages> = {
  es: localeSuggestionEs,
  en: localeSuggestionEn,
  pt: localeSuggestionPt,
  it: localeSuggestionIt,
  fr: localeSuggestionFr,
  ja: localeSuggestionJa,
  de: localeSuggestionDe,
}

/** `locale-suggestion.json` con la marca resuelta al acceder. */
export function getLocaleSuggestionMessages(locale: PublicLocale): LocaleSuggestionMessages {
  return brandMessages(LOCALE_SUGGESTION_BY_LOCALE[locale])
}
